<template>
  <div id="app" ref="app">

    <router-view></router-view>
<!--    <BackTop />-->
<!--    <Affix />-->
    <div class="floating-component">
      <!-- 悬浮内容 -->
      <el-tooltip placement="left" effect="light" popper-class="too">
        <div slot="content">
          <div class="title">综合咨询</div>
          <div class="num" @click="callPhone(4000339003)">400-033-9003</div>
          <div class="title">售前咨询</div>
          <div class="num1" @click="callPhone(13603710470)">13603710470</div>
<!--          <el-button icon="el-icon-s-comment" class="butto" @click="handleQuestion">问题反馈 </el-button>-->
<!--          <br/>-->
<!--          <el-button icon="el-icon-question" class="butto" @click="handleHelp">帮助手册 </el-button>-->
        </div>

        <el-button circle class="but"><img src="../src/assets/img/home/call.svg" class="top"/></el-button>
      </el-tooltip>
    </div>
    <div class="floating-component1">
      <!-- 悬浮内容 -->
<!--      <el-tooltip class="item" effect="dark" content="点击留言" placement="top">-->
        <el-button circle class="but"><img src="../src/assets/img/home/msg.svg" class="top" @click="$router.push('/Experience')"/></el-button>
<!--      </el-tooltip>-->
    </div>
    <el-backtop :bottom="20" :right="10" >
      <el-tooltip placement="right" effect="dark" class="item" content="回到顶部" >
      <img src="../src/assets/img/home/top.svg" class="top"/>
      </el-tooltip>
    </el-backtop>
    </div>
</template>

<script>
// import Home from '@/views/Home'
export default {
  name: 'App',
  components: {
    // Home,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  methods:{
    callPhone (num) {
      window.location.href = 'tel://' + num
    },
  }
}
</script>

<style lang="scss">

.production_img_inner {
  width: 70%;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-left: 10PX;
  }
}
a{ text-decoration: none; }
.el-backtop{
  width: 50px !important;
  height: 50px !important;
  background: linear-gradient(180deg, rgba(12, 87, 249, 1) 0%, rgba(75, 147, 255, 1) 100%) !important;
  border: 2.08px solid rgba(255, 255, 255, 1) !important;
  box-shadow: 0px 4.16px 16.62px  rgba(192, 199, 218, 0.3) !important;
  @media screen and (max-width: 768px) {
    width: 40PX !important;
    height: 40PX !important;
  }
}
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');

.too.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 5px;
  @media screen and (max-width: 768px) {
    padding: 5PX !important;
  }
}
/* 修改箭头边框 这里方位是left，所以 x-placement^="left" 并且是设置 border-right-color 的颜色*/
.too.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
.too.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
</style>
<style lang="scss" scoped>
.el-button.is-circle {
  width: 53px;
  height: 53px;
  background: linear-gradient(180deg, rgba(243, 245, 248, 1) 0%, rgba(254, 254, 254, 1) 100%);
  border: 2.08px solid rgba(255, 255, 255, 1) !important;
  box-shadow: 0px 4.16px 16.62px  rgba(192, 199, 218, 0.3) !important;
  @media screen and (max-width: 768px) {
    width: 40PX;
    height: 40PX;
  }

}
.top{
  width:20px;
  @media screen and (max-width: 768px) {
    width: 1.2rem;
  }
}
.floating-component {
  position: fixed; /* 固定位置 */
  bottom: 84px; /* 下边距 */
  right: 10px; /* 右边距 */
  padding: 0;
  border-radius: 50%; /* 圆角 */
  z-index: 999; /* 设置 z-index 确保悬浮在顶层 */
  @media screen and (max-width: 768px) {
    bottom: 70PX;
    right: 10PX; /* 右边距 */
  }
}
.floating-component1 {
  position: fixed; /* 固定位置 */
  bottom: 152px; /* 下边距 */
  right: 10px; /* 右边距 */
  padding: 0;
  border-radius: 50%; /* 圆角 */
  z-index: 999; /* 设置 z-index 确保悬浮在顶层 */
  @media screen and (max-width: 768px) {
    bottom: 120PX;
    right: 10PX; /* 右边距 */
  }
}
.but {
  font-size: 26px;
  color: #0052D9;
  font-weight: 600 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); /* 阴影 */

}
.title{
  padding: 20px 50px 0 20px;
  @media screen and (max-width: 768px) {
    padding: 20PX 50PX 0 20PX;
    font-size: 0.8rem;
  }
}
.num{
  line-height: 24px;
  font-size: 16px;
  color: #0052D9;
  padding: 10px 50px 0 20px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    padding: 10PX 50PX 0 20PX;
    font-size: 1.1rem;line-height: 24PX;

  }
}
.num1{
  color: #0052D9;
  line-height: 24px;
  font-size: 16px;
  padding: 10px 50px 20px 20px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    padding: 10PX 50PX 0 20PX;
    font-size: 1.1rem;
    line-height: 30PX;
  }
}
::v-deep(.el-backtop){
  right: 12px !important; /* 右边距 */
  bottom: 20px !important;
  @media screen and (max-width: 768px) {
    right: 10PX !important;
    bottom: 18PX !important;
  }
}
</style>
